import axios from "axios";

const env = process.env;

const productionUrl = "https://api.moneyhubservice.com";
// const productionUrl = "https://j3glljytyvmcsgpo2cugffk3by0vivjw.lambda-url.ap-southeast-1.on.aws";

const instance1337 = axios.create({
  baseURL:
    env.NODE_ENV === "development" ? "http://localhost:1337" : productionUrl,
});
const instance1338 = axios.create({
  baseURL:
    env.NODE_ENV === "development" ? "http://localhost:1338" : productionUrl,
});

const responseInterceptors = (response) => {
  return response?.data;
};

instance1337.interceptors.response.use(responseInterceptors);
instance1338.interceptors.response.use(responseInterceptors);

const buildRequestBody = (restBody = {}, method) => {
  if (["get"].includes(method)) {
    return {
      params: restBody?.queryStringParameters,
      ...restBody,
    };
  }

  return {
    ...restBody?.body,
  };
};

const instanceObj = {
  1337: instance1337,
  1338: instance1338,
};

const API = {
  put: (projectName, path, restBody, port = 1337) => {
    return instanceObj[port].put(path, buildRequestBody(restBody, "put"))
  },
  patch: (projectName, path, restBody, port = 1337) => {
    return instanceObj[port].patch(path, buildRequestBody(restBody, "patch"));
  },
  post: (projectName, path, restBody, port = 1337) => {
    return instanceObj[port].post(path, buildRequestBody(restBody, "post"));
  },
  get: async (projectName, path, restBody, port = 1337) => {
    return instanceObj[port].get(path, buildRequestBody(restBody, "get"));
  },
  del: (projectName, path, restBody, port = 1337) => {
    return instanceObj[port].delete(path, buildRequestBody(restBody, "del"));
  },
};

export default API;
